import React from 'react';
import {
  AddAdjustment, Inactive, ConfirmDeposit, Postponed, SendFirstMessage,
} from '../../../components/alerts';
import { AlertObj, AlertType } from '../../../components/alerts/utils';

const Alerts = ({
  alert,
}: { alert: AlertObj }) => {
  switch (alert.type) {
    case AlertType.FirstMessageReminder:
      if (!alert.url || !alert.createdAt) return null;
      return <SendFirstMessage url={alert.url} createdAt={alert.createdAt} />;
    case AlertType.DepositConfirmation:
      return alert.url ? <ConfirmDeposit url={alert.url} /> : null;
    case AlertType.SalesAdjustment:
      return alert.url ? <AddAdjustment url={alert.url} /> : null;
    // Cancellation banners (SOLD_CANCELED / REFUNDED_CANCELED / TRAVELER_CANCELED) are NOT shown on the Sales tab, but they live on the Trip Details page and the sidebar only.
    case AlertType.Postponed:
      return alert.handleReactivation ? <Postponed handleReactivation={alert.handleReactivation} /> : null;
    case AlertType.Inactive:
      return alert.handleReactivation ? <Inactive handleReactivation={alert.handleReactivation} /> : null;
    default:
      return null;
  }
};

export default Alerts;
